<header class="gold-rule flex shrink-0 items-center gap-3 px-4 pt-[calc(1rem+env(safe-area-inset-top))] pb-4">
  <div class="min-w-0 flex-1">
    <h2 class="text-body text-gold-cream font-bold">Notificaciones</h2>

    <p class="text-label text-blue-frost mt-1">@if (store.unread(); as unread) { {{ unread }} sin leer } @else { Estás al día }</p>
  </div>

  <button
    type="button"
    aria-label="Cerrar notificaciones"
    class="text-blue-sky shrink-0 transition-transform duration-100 ease-out active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
    (click)="dialogRef.close()">
    <icon
      name="circle-x"
      [size]="20" />
  </button>
</header>

<ul
  class="flex flex-1 flex-col gap-3 overflow-y-auto overscroll-contain p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]"
  [attr.aria-busy]="store.loading()">
  @for (item of store.notifications(); track item.id) {
  <li>
    <notification-item
      [notification]="item"
      (selected)="select($event)" />
  </li>
  } @empty { @if (store.loading()) { @for (item of [1, 2, 3]; track item) {
  <li data-test="notification-skeleton">
    <notification-item-skeleton />
  </li>
  } } @else {
  <li class="text-label text-blue-frost py-10 text-center font-medium">No tienes notificaciones.</li>
  } }
</ul>
